<div class="root-div">
  <button mat-icon-button [matTooltip]="isExpanded ? 'Collapse All' : 'Expand All'" matTooltipPosition="below" class="toggle-expand-button" [disabled]="!hasExpandableNodes" (click)="onToggleExpand()">
    <mat-icon fontSet="material-symbols-outlined">{{ isExpanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
  </button>
</div>
